import { Card } from "reactstrap"
import styled from "styled-components"

export const StyledCard = styled(Card).attrs(() => ({
    className: "border-0 shadow  card-timeline  mb-4"
}))``


export const StyledIframe = styled.iframe.attrs(() => ({
    title: "Parent Connect",
    id: "desktop-cctv2",
    width: "100%",
    height: "700",
    name: "live",
    align: "center",
    frameBorder: "0",
    scrolling: "yes",
    allowtransparency: "true",
    allowFullScreen: "allowfullscreen",
    mozallowfullscreen: "mozallowfullscreen",
    msallowfullscreen: "msallowfullscreen",
    oallowfullscreen: "oallowfullscreen",
    webkitallowfullscreen: "webkitallowfullscreen"
}))``
